import { AuthContext } from 'contexts';
import { useLocalStorage } from 'react-use';
import { revokeToken, tokenIntrospection } from '../api/auth';
import { useKoobStore } from 'store';

const AuthProvider = ({ children }) => {
  const [realAccessToken, setAccessToken] = useLocalStorage('accessToken', '', {
    raw: true,
  });
  const [refreshToken, setRefreshToken] = useLocalStorage('refreshToken', '', {
    raw: true,
  });
  const [impersonationToken, setImpersonationToken] = useLocalStorage(
    'impersonationToken',
    '',
    {
      raw: true,
    },
  );

  const handleUpdate = ({ accessToken, refreshToken }) => {
    setAccessToken(accessToken);
    setRefreshToken(refreshToken);
  };

  const handleReset = async () => {
    revokeToken()
      .then()
      .catch(error => {
        console.error(
          `An error occurred while revoking the token: ${error.message}`,
        );
      })
      .finally(() => {
        setAccessToken('');
        setRefreshToken('');
        setImpersonationToken('');
        useKoobStore.persist.clearStorage();
        window.location.reload();
      });
  };

  const handleTokenIntrospection = () => tokenIntrospection();

  return (
    <AuthContext.Provider
      value={{
        accessToken:
          impersonationToken?.length > 0 ? impersonationToken : realAccessToken,
        refreshToken,
        logout: handleReset,
        onUpdate: handleUpdate,
        impersonating: !!impersonationToken,
        setImpersonationToken,
        isActiveToken: handleTokenIntrospection,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
